export default "<adn-folio-list list=\"list\"></adn-folio-list>";